import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Eye, ExternalLink, Megaphone } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const CHANNELS = {
  telegram: { label: 'Telegram', color: '#0088cc' },
  max: { label: 'MAX', color: '#6C47FF' },
  vk: { label: 'VK', color: '#0077FF' },
};

export default function AnnouncementStats({ gameId, refreshKey }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    axios.get(`${API}/games/${gameId}/announcements`, { headers: getAuthHeader() })
      .then(r => { if (!cancelled) setItems(r.data?.announcements || []); })
      .catch(() => { if (!cancelled) setItems([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [gameId, refreshKey]);

  if (loading || items.length === 0) return null;

  return (
    <div data-testid="announcement-stats" style={{
      margin: '10px 0 16px', padding: '12px 16px', borderRadius: 12,
      border: '1px solid #e5e7eb', background: '#f8fafc',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 700, color: '#374151', marginBottom: 8 }}>
        <Megaphone size={15} /> Статистика анонсов
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {items.map(a => {
          const ch = CHANNELS[a.channel] || { label: a.channel, color: '#6b7280' };
          const date = a.created_at ? new Date(a.created_at).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';
          return (
            <div key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, flexWrap: 'wrap' }}>
              <span style={{
                display: 'inline-block', minWidth: 70, textAlign: 'center', padding: '2px 8px',
                borderRadius: 999, background: ch.color, color: 'white', fontWeight: 600, fontSize: 12,
              }}>{ch.label}</span>
              <span style={{ color: '#6b7280' }}>{date}</span>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: '#374151', fontWeight: 600 }}>
                <Eye size={14} /> {a.views != null ? a.views.toLocaleString('ru-RU') : '—'}
              </span>
              {a.url && (
                <a href={a.url} target="_blank" rel="noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 3, color: '#0a4797' }}>
                  открыть <ExternalLink size={12} />
                </a>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
